module.exports = __webpack_public_path__ + "static/img/3.29c766f8.png";